import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Facebook } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function Footer() {
  return (
    <footer className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src="/pickle-wall-logo.png"
              alt="Pickle Wall — Hold The Line"
              className="h-20 w-auto object-contain mb-5"
            />
            <p className="text-white/60 max-w-sm leading-relaxed">
              Train Anytime. Dominate Everywhere. A portable pro
              pickleball net — built for serious players, coaches, and clubs.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: Instagram, href: "https://instagram.com/itspicklewall", label: "Pickle Wall on Instagram" },
                { icon: Twitter, href: null, label: "X (coming soon)" },
                { icon: Youtube, href: null, label: "YouTube (coming soon)" },
                { icon: Facebook, href: null, label: "Facebook (coming soon)" },
              ].map((s, i) =>
                s.href ? (
                  <a
                    key={i}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${i}`}
                    onClick={() => trackEvent("social_link_click", { button_text: s.label, button_location: "footer" })}
                    className="w-10 h-10 rounded-xl border border-white/10 flex items-center justify-center text-white/70 hover:text-[#FF6B00] hover:border-[#FF6B00]/40 transition-colors"
                    aria-label={s.label}
                  >
                    <s.icon size={18} />
                  </a>
                ) : (
                  <span
                    key={i}
                    data-testid={`footer-social-${i}`}
                    className="w-10 h-10 rounded-xl border border-white/5 flex items-center justify-center text-white/25 cursor-default"
                    aria-label={s.label}
                    title={s.label}
                  >
                    <s.icon size={18} />
                  </span>
                )
              )}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/50 mb-4">
              Product
            </div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><Link to="/shop" className="hover:text-[#FF6B00]">Shop</Link></li>
              <li><Link to="/academy" className="hover:text-[#FF6B00]">Academy</Link></li>
              <li><a href="/#ecosystem" className="hover:text-[#FF6B00]">Ecosystem</a></li>
              <li><a href="/#pro-48" className="hover:text-[#FF6B00]">PRO 48</a></li>
              <li><a href="/#how-it-works" className="hover:text-[#FF6B00]">How It Works</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/50 mb-4">
              Company
            </div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><a href="/#our-story" className="hover:text-[#FF6B00]">Our Story</a></li>
              <li><Link to="/contact" className="hover:text-[#FF6B00]">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/50 mb-4">
              Stay in the loop
            </div>
            <p className="text-sm text-white/60 mb-4">
              Join Team Pickle Wall for early access and weekly tips.
            </p>
            <a
              href="/contact"
              className="inline-flex items-center bg-[#FF6B00] hover:bg-[#E66000] text-black font-bold uppercase tracking-wider text-xs px-5 py-3"
              data-testid="footer-cta-join"
            >
              Join Now
            </a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/5 flex flex-col md:flex-row gap-3 md:items-center justify-between text-xs text-white/40">
          <div>© {new Date().getFullYear()} Pickle Wall™. Patent Pending. All rights reserved.</div>
          <div className="flex flex-wrap gap-6">
            <Link to="/privacy-policy" className="hover:text-white">Privacy</Link>
            <Link to="/terms-of-service" className="hover:text-white">Terms</Link>
            <Link to="/return-policy" className="hover:text-white">Returns</Link>
            <Link to="/shipping-policy" className="hover:text-white">Shipping</Link>
            <Link to="/warranty" className="hover:text-white">Warranty</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
